import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

export const useLanguage = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const getCurrentLanguage = () => {
    const path = location.pathname;
    const languageMatch = path.match(/^\/([a-z]{2})(?:\/|$)/);
    return languageMatch ? languageMatch[1] : i18n.language;
  };

  const currentLanguage = getCurrentLanguage();

  const changeLanguage = (langCode) => {
    // Save to localStorage
    localStorage.setItem('i18nextLng', langCode);

    // Change i18n language
    i18n.changeLanguage(langCode);

    // Update URL
    const currentPath = location.pathname;
    const pathWithoutLang = currentPath.replace(/^\/[a-z]{2}/, '') || '/';
    const searchParams = location.search; // Preserve query parameters
    const newPath = `/${langCode}${pathWithoutLang}${searchParams}`;

    navigate(newPath);
  };

  const getLocalizedPath = (path) => {
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return `/${currentLanguage}/${cleanPath}`;
  };

  const isCurrentLanguage = (langCode) => {
    return currentLanguage === langCode;
  };

  return {
    currentLanguage,
    changeLanguage,
    getLocalizedPath,
    isCurrentLanguage,
  };
};
